import React from 'react';
import { cx } from '../cx';

// D-09 §15.16 — Counter (.counter > button − / input / button ＋) · controlled
// 구 Stepper(수량 +/− 컨트롤) 개명. 버튼 정사각·원형(패딩0), input 외곽선 없음.
// orientation='vertical' — 숫자 input 옆에 위(▲ 증가)·아래(▼ 감소) 삼각형 스피너를 세로로.
// '착공 [스피너] 일 전'처럼 '−' 문자와 감소 버튼이 겹쳐 헷갈리는 자리에서 쓴다.
export interface CounterProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  size?: 'sm' | 'md' | 'lg';
  orientation?: 'horizontal' | 'vertical';
}

export function Counter({ value, onChange, min = 0, max = Number.MAX_SAFE_INTEGER, size = 'md', orientation = 'horizontal', className = '', ...props }: CounterProps) {
  const clamp = (n: number) => Math.min(max, Math.max(min, n));
  const onInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const n = Number(e.target.value);
    if (!Number.isNaN(n)) onChange(clamp(n));
  };

  if (orientation === 'vertical') {
    return (
      <div className={cx('counter', 'counter-vertical', size !== 'md' && `counter-${size}`, className)} {...props}>
        <input value={value} inputMode="numeric" onChange={onInput} />
        <div className="counter-spin">
          <button type="button" aria-label="증가" onClick={() => onChange(clamp(value + 1))}>
            <svg width="10" height="7" viewBox="0 0 10 7" aria-hidden="true">
              <polygon points="5,0 10,7 0,7" fill="currentColor" />
            </svg>
          </button>
          <button type="button" aria-label="감소" onClick={() => onChange(clamp(value - 1))}>
            <svg width="10" height="7" viewBox="0 0 10 7" aria-hidden="true">
              <polygon points="0,0 10,0 5,7" fill="currentColor" />
            </svg>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={cx('counter', size !== 'md' && `counter-${size}`, className)} {...props}>
      <button type="button" aria-label="감소" onClick={() => onChange(clamp(value - 1))}>
        −
      </button>
      <input value={value} inputMode="numeric" onChange={onInput} />
      <button type="button" aria-label="증가" onClick={() => onChange(clamp(value + 1))}>
        ＋
      </button>
    </div>
  );
}
